// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { lightningBolt16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-lightning-bolt': IconLightningBolt;
    }
}

/**
 * The icon component for the 'lightningBolt' icon
 */
export class IconLightningBolt extends IconSvg {
    public constructor() {
        super(lightningBolt16X16);
    }
}

registerIconSvg('icon-lightning-bolt', IconLightningBolt);
export const iconLightningBoltTag = 'nimble-icon-lightning-bolt';
